import { Component, OnInit,Input, ViewChild } from '@angular/core';
import { Agent,AgentServicev2 } from '../agent-builder-services/agent.service';
import { NzTableComponent, NzTableFilterValue, NzTableQueryParams, NzTableSortOrder } from 'ng-zorro-antd/table';


export interface LogEntry {
  _id: string;
  CODECOMPANY: any;
  RECMODIFIEDON: string;
  SESSIONID: string | null;
  HEADER: string;
  INTIME: string;
  REQUESTID: string;
  IDHOOK: any;
  CODEMKTP: any;
  REQUESTHOOK: string;
  CODECONTRACT: any;
  DATAIN: string;
  STATUS: string;
  RECMODIFIEDBY: number;
  SERVICENAME: string;
  DATAMID: string; // array serializado
  DATAOUT: string;
  DURATION: number;
  MESSAGE: string;
  OUTTIME: string;
  RESPONSEHOOK: string;
}

@Component({
  selector: 'agent-builder-mcp-log',
  templateUrl: './agent-builder-mcp-log.component.html',
  styleUrls: ['./agent-builder-mcp-log.component.scss'],
  standalone: false
})
export class AgentBuilderMcpLogComponent implements OnInit {
  logs: LogEntry[] = [];
  loading = false;

  @ViewChild('nzTable',{ static: false }) table:NzTableComponent<any>;
  
  visible: Record<string, boolean> = {
    _id: false,
    REQUESTID: false,
    SESSIONID: false,
    IDHOOK: false,
    INTIME: false,
    STATUS: false
  };

  searchData: Record<string, string> = {
    _id: null,
    REQUESTID: null,
    SESSIONID: null,
    IDHOOK: null,
    INTIME: null,
    STATUS: null
  };
  activeColumnKey = '_id';
  activeDateValue: Date | null = null;
  expandSet = new Set<string>();  
  currentFilter: { key: string; value: NzTableFilterValue }[] = [];

  onExpandChange(id: string, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  
  pageIndex = 1;
  pageSize = 20;
  total = 0;

  sortField: string | null = null;
  sortOrder: string | null = null;

  constructor(private agentService: AgentServicev2) {}

  @Input() agent: Agent;


  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;

    this.agentService
      .getMCPLogs(this.agent, this.currentFilter, this.pageIndex-1, this.pageSize, this.sortField, this.sortOrder)
      .subscribe((res:any) => {
        this.logs = res.SQL || [];
        this.total = res.totalLines;
        this.loading = false;
      });
  }

  parseData(data: string): any {
    if ( data == null || data.trim() === '') {
      return '{}';
    }
    try {
      return JSON.stringify(JSON.parse(data),null, 2);
    } catch {
      return JSON.stringify(data, null, 2);
    } 
  }


  onFilterVisibleChange(field: string, isVisible: boolean): void {
    this.visible[field] = isVisible;
    if (isVisible) {
      this.activeColumnKey = field;
      this.activeDateValue = this.searchData[field] ? new Date(this.searchData[field]) : null;
    }
  }

  onDateSelected(date: Date | null, field: string): void {
    this.activeDateValue = date;
    if (!date) {
      this.searchData[field] = '';
      return;
    }
    // Converte Date para string no formato yyyy-MM-dd HH:mm:ss
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    this.searchData[field] = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }


  search(field: string) {
        let index = this.currentFilter.findIndex(d=>d.key==field);
        console.log(this.searchData)
        if  ( index == -1 ){
            this.currentFilter.push({
            key:field,
            value:this.searchData[field]
            })
        }else{
            this.currentFilter.find(d=>d.key==field).value = this.searchData[field];
        }
        
        let param:NzTableQueryParams = { 
            pageSize:this.table.nzPageSize,
            pageIndex: this.table.nzPageIndex,
            sort: [],
            filter: this.currentFilter
        }
        this.table.nzQueryParams.emit(param);
        
        this.visible[field] = false;
        
    }

  reset(field: string): void {
    this.searchData[field] = '';
    if (this.activeColumnKey === field) {
      this.activeDateValue = null;
    }
    let index = this.currentFilter.findIndex(d=>d.key==field);
    if (index !== -1) {
      this.currentFilter.splice(index,1);
    }
    this.search(field);
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
        
        let { pageSize, pageIndex, sort, filter } = params;
        
        if ( this.currentFilter.length > 0 ){
            filter = this.currentFilter;
        }

        const currentSort = sort.find(item => item.value !== null);
        this.sortField = (currentSort && currentSort.key) || '_id';
        this.sortOrder = (currentSort && currentSort.value) || 'descend';
        this.loadData();
        
        if ( sort.length > 0 ){
            this.sortFields(sort);
        }
    }

    sortFields(sort: {key:string,value:NzTableSortOrder}[]) {
       for (var item of sort ){
        if ( item.value != null ){
            
            this.logs.sort((a, b) => {
            if (typeof a[item.key] === 'string' && typeof b[item.key] === 'string') {
                
                    if ( a[item.key] > b[item.key] ) {
                        return 1 * (item.value == 'ascend' ? 1 : -1);
                    }
                    if ( a[item.key] < b[item.key] ) {
                        return -1 * (item.value == 'ascend' ? 1 : -1);
                    }
                    return 0;


            } else {
                return item.value === 'ascend'
                    ? Number(a[item.key]) - Number(b[item.key])
                    : Number(b[item.key]) - Number(a[item.key]);
            }
            
            });
          }
       }
    }
}


